module.exports = __webpack_public_path__ + "static/media/unselectedTextHover.cd42eba4.png";